<template>
  <section class="relative">
    <!-- Banner area — diagonal dot pattern like Luma -->
    <div class="relative w-full h-52 sm:h-64 overflow-hidden bg-zinc-950 dark:bg-zinc-950">
      <div class="hero-dots absolute inset-0" />
      <!-- Gradient fade bottom -->
      <div class="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-background to-transparent" />
    </div>

    <!-- Profile area — overlapping banner -->
    <div class="relative z-10 max-w-5xl mx-auto px-6">
      <div class="-mt-8 mb-8">
        <!-- Avatar -->
        <div class="size-16 rounded-2xl border-4 border-background overflow-hidden mb-5">
          <NuxtImg
            src="/images/aing-2.webp"
            alt="Irfan Hardiyanto"
            width="64"
            height="64"
            class="w-full h-full object-cover"
          />
        </div>

        <!-- Name + role -->
        <div class="animate-fade-up">
          <h1
            id="hero-name"
            class="text-4xl sm:text-5xl font-bold text-highlighted tracking-tight mb-1"
          >
            Irfan Hardiyanto
          </h1>
          <p class="text-base text-muted font-medium mb-3">
            Fullstack Web Developer · West Java, Indonesia
          </p>
        </div>

        <!-- Bio -->
        <p class="animate-fade-up-delay-1 text-base text-muted leading-relaxed max-w-xl mb-5">
          7+ years building high-performance web applications — from enterprise CMS platforms to modern Vue/React products.
        </p>

        <!-- Social + CTA row -->
        <div class="animate-fade-up-delay-2 flex flex-wrap items-center gap-2">
          <UButton
            size="sm"
            to="#contact"
            trailing-icon="i-lucide-arrow-right"
          >
            Contact Me
          </UButton>
          <UButton
            size="sm"
            variant="outline"
            to="/irfan-hardiyanto-resume.pdf"
            target="_blank"
            trailing-icon="i-lucide-download"
          >
            Resume
          </UButton>

          <div class="w-px h-5 bg-border mx-1" />

          <UButton
            to="https://github.com/devhardiyanto"
            target="_blank"
            icon="i-simple-icons-github"
            variant="ghost"
            size="sm"
            aria-label="GitHub"
          />
          <UButton
            to="https://linkedin.com/in/ihardiyanto"
            target="_blank"
            icon="i-simple-icons-linkedin"
            variant="ghost"
            size="sm"
            aria-label="LinkedIn"
          />
          <UButton
            to="mailto:dev.hardiyanto@gmail.com"
            icon="i-lucide-mail"
            variant="ghost"
            size="sm"
            aria-label="Email"
          />
        </div>
      </div>

      <USeparator class="mb-0" />
    </div>
  </section>
</template>
